<template>
  <div class="row summary-item">
    <div class="col-3 col-md-2">
      <fa :fa-class="faClass"></fa>
    </div>

    <div class="col-9 col-md-10">
      <div class="title">
        {{ title }}
      </div>

      <slot class="content"></slot>
    </div>
  </div>
</template>

<script>
import fa from '@/components/global/icon/fontAwesome'

export default {
  components: {
    fa
  },
  props: {
    title: {
      type: String,
      required: true
    },
    faClass: {
      type: String,
      required: true
    }
  }
}
</script>
